import { MINUTES_IN_DAY, MINUTES_IN_HOUR } from '@repo/date-time';
export const PRESET_MIDNIGHT_MINUTES = 0;
export const PRESET_MORNING_MINUTES = 8 * MINUTES_IN_HOUR;
export const PRESET_AFTERNOON_MINUTES = 16 * MINUTES_IN_HOUR;
export const PRESET_END_OF_DAY_MINUTES = MINUTES_IN_DAY;
export const FAR_FUTURE_YEARS = 50;
